import fetch from 'isomorphic-fetch';


import materialStore, { getBenchMaterial, getProfileMaterial, getPanelMaterial, getBenchMaterials, getProfileMaterials, getPanelMaterials, getDefaultBenchMaterial } from '../reducers/materialStore';
import localization from '../helpers/localization.js';
import { countries } from '../helpers/localization.js';
import { updateOptionRows, updateBenchPriceOptions } from './optionPricing';
import { updateCadImage } from './benchCadImage';
import { serviceroot, layerPath,stoves } from '../config';
import benchImageCache from '../helpers/benchImageCache';
import { doorFromLeftUpdated, restoreDefaultGlassWall } from './door';
import { updateMaterialImageOrSetPending, renderMaterialImage } from './materialImage.ts';
import { lightOptions } from '../reducers/saunaLightning';
import { lightType } from '../helpers/enums';
import { getBenchModelDefaultPositions, positionsMatch } from '../helpers/benchModelPositioning';

var fetch_retry = require('fetch-retry')(fetch);
var materialService = serviceroot + "api/MaterialOptionModel";

export const changeModel = (model) => {
    return ((dispatch, getState) => {
        let state = getState();
        let oldBench = state.benchModel;
        const positioningWasMoved = getPositioningWasMoved(state.measurements);
        dispatch({
            type: 'CHANGE_MODEL',
            model: model,
            material: (oldBench.model.name === model.name && oldBench.material) ? oldBench.material : getDefaultBenchMaterial(state, model)?.id,
            profileMaterial: (oldBench.profileMaterial) ? oldBench.profileMaterial : 1
        });
        applyBenchModelDefaultPositions(dispatch, getState, positioningWasMoved);
        dispatch(benchChanged(getState().benchModel));
    });
}


export const changeShape = (shape) => {
    return ((dispatch, getState) => {
        const positioningWasMoved = getPositioningWasMoved(getState().measurements);
        dispatch({
            type: 'CHANGE_SHAPE',
            shape
        });
        applyBenchModelDefaultPositions(dispatch, getState, positioningWasMoved);
        dispatch(benchChanged(getState().benchModel));
    });
}
export const changeBenchMaterial = (materialId) => {
    return ((dispatch, getState) => {
        dispatch({
            type: 'CHANGE_BENCH_MATERIAL',
            id: materialId
        });
        let state = getState();
        let bench = state.benchModel;
        let newMaterial = getBenchMaterial(state, materialId);
        if (newMaterial.defaultProfileMaterial && newMaterial.defaultProfileMaterial !== state.benchModel.profileMaterial) {
            bench.profileMaterial = newMaterial.defaultProfileMaterial;
        }
        dispatch(benchChanged(bench));
    });
}

export const changeProfileMaterial = (materialId) => {
    return ((dispatch, getState) => {
        dispatch({
            type: "CHANGE_PROFILE_MATERIAL",
            id: materialId
        });
        dispatch(benchChanged(getState().benchModel));
    })
};


export const mirrorBench = () => {
    return ((dispatch, getState) => {
        const positioningWasMoved = getPositioningWasMoved(getState().measurements);
        dispatch({
            type: 'MIRROR_BENCH'         
        });
        applyBenchModelDefaultPositions(dispatch, getState, positioningWasMoved);
        dispatch(benchChanged(getState().benchModel));
    });
}







export const benchChanged = (bench) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'BENCH_CHANGED',
            bench: bench
        });
        let state = getState();
        dispatch(updateMaterialImageOrSetPending());
        dispatch(filterAvailableLights());
        if (state.measurements.depth > 0 && state.measurements.doorWallWidth > 0) dispatch(updateCadImage());
        if (state.clientConfiguration.showPrices) {
            dispatch(updateOptionRows());
            dispatch(updateBenchPriceOptions());
        }
    }
}
export const filterAvailableLights = () => {
    return (dispatch, getState) => {
        let state = getState();
        let avalaibleLights = filterAvalaibleLightsBasedOnBench(state.saunaLighting, state.benchModel, state.plan);         
        dispatch({
            type: 'AVAILABLE_LIGHTS_CHANGED',
            avalaibleLights: avalaibleLights
        });
        let selectedLight = state.saunaLighting.selectedLight;
        if (!avalaibleLights.find(s => s.id == selectedLight.id)) {
            if (selectedLight.id == lightType.LedStripe)
                selectedLight = lightOptions[lightType.Bench];
            else if (selectedLight.id == lightType.LinearWithStove || selectedLight.id == lightType.LedStripWithStove)
                selectedLight = lightOptions[lightType.BenchWithStove];
                dispatch(changeLinghtning(selectedLight.id));     
            }
    }
}
let filterAvalaibleLightsBasedOnBench = (state, bench,plan) => {
    let result = []
    if (!bench || bench.model.supportsLinearLed || plan.hasBench === false) {
        result.push(lightOptions[lightType.LedStripe]);
        result.push(lightOptions[lightType.LedStripWithStove]);
    }
    result.push(lightOptions[lightType.Bench]);
    result.push(lightOptions[lightType.BenchWithStove]);
    result.push(lightOptions[lightType.RoofWithStove]);
    if (state.allowNoLightSelection)
        result.push(lightOptions[lightType.NoLigthing]);
    return result;
}




export const requestMaterials = () => ({
    type: 'REQUEST_MATERIAL_UPDATE'
});

export const updateMaterials = () => ({
    type: 'UPDATEMATERIALS'
});

export const receiveMaterialUpdate = (response) => ({
    type: 'RECEIVE_MATERIAL_UPDATE',
    panelMaterials: response.panelMaterials,
    profileMaterials: response.profileMaterials,
    benchMaterials: response.benchMaterials,
    glassMaterials: response.glassMaterials,
    glassListMaterials: response.glassListMaterials
});




export const saunaCadImageUpdated = (image) => ({
    type: "SAUNACADIMAGE_UPDATED",
    image: image
});


export const changePanelMaterial = (materialId) => {
    return ((dispatch) => {
        dispatch({
            type: 'CHANGE_PANEL_MATERIAL',
            id: materialId
        });
        dispatch(updateOptionRows());
        dispatch(updateMaterialImageOrSetPending());
    });
}

export const changePanelDirection = (panelingDirection) => {
    return ((dispatch) => {
        dispatch({
            type: 'CHANGE_PANELINGDIRECTION',
            direction: panelingDirection
        });
        dispatch(updateOptionRows());
        dispatch(updateMaterialImageOrSetPending());
    });
}


export const closeInstructionModal = () => ({
    type: "CLOSE_INSTRUCTION_MODAL"
});
export const showInstructionModal = () => ({
    type: "SHOW_INSTRUCTION_MODAL"
});

export const updateContactDetails = (contactDetails) => ({
    type: 'UPDATE_CONTACT_DETAILS',
    contactDetails: contactDetails
});






export const changeStove = (stove) => {
    return ((dispatch) => {
        dispatch({
            type: 'STOVE_CHANGED',
            stove: stove
        });
        dispatch(updateOptionRows());
        dispatch(updateMaterialImageOrSetPending());
    });
}
export const stoveDescriptionChanged = (description) => ({
    type: "STOVE_DESCRIPTION_CHANGED",
    description: description
});

export const changeUILanguane = (language) => {
    localization.setLanguage(language);
    countries.setLanguage(language);
    return {
        language: language,
        type: 'CHANGE_LANGUAGE'
    };   
}





export const availableStovesChanged = (stoves) => ({
    type: 'AVAILABLE_STOVES_CHANGED',
    stoves: stoves
});


export const materialStoreUpdated = (defaultBenchMaterial, defaultPanelMaterial, defaultProfilematerial) => ({
    type: "MATERIAL_STORE_UPDATED",
    defaultBenchMaterial: defaultBenchMaterial,
    defaultPanelMaterial: defaultPanelMaterial,
    defaultProfilematerial: defaultProfilematerial
});



export const mainSlideChanged = (index, title, descriptionLocalizationStringName, previousSlideAvalaible, nextSlideAvalaible, materialImageShown) => {
    return ((dispatch,getState) => {
        dispatch({
            type: 'mainSlideChanged',
            index: index,
            title: title,
            descriptionLocalizationStringName: descriptionLocalizationStringName,
            previousSlideAvalaible: previousSlideAvalaible,
            nextSlideAvalaible: nextSlideAvalaible,
            materialImageShown: materialImageShown
        });
        if (materialImageShown && getState().materialImage.isUpdatePending) {
            dispatch(renderMaterialImage());
        }      
    });    
}


export const changeLinghtning = (selectedLight, fibers) => {
    return ((dispatch) => {
        dispatch({
            type: "LIGHTING_CHANGED",
            selectedLight: selectedLight,
            fibers: fibers
        });
        dispatch(updateOptionRows());
        dispatch(updateMaterialImageOrSetPending());
    });
}

    



export const showAlert = (alertMessage) => {
    return {
        type: 'SHOW_ALERT',
        alertMessage: alertMessage
    };
}
export const hideAlert = () => {
    return {
        type: 'HIDE_ALERT'
    };
}

export const displayError = (show, errorMessage) => {
    return {
        type: 'DISPLAY_ERROR',
        displayError: show,
        errorMessage: errorMessage
    };
}


export const measurementsUpdated = (measurements) => {
    return function (dispatch, getState) {
        const positioningWasMoved = getPositioningWasMoved(getState().measurements);
        dispatch({
            type: 'ROOM_MEASUREMENTS_UPDATED',
            measurements: measurements
        });
        dispatch(filterShapes());
        applyBenchModelDefaultPositions(dispatch, getState, positioningWasMoved);
        const updatedMeasurements = getState().measurements;
        const canInitializeGlassWall = updatedMeasurements.doorWallWidth > 0
            && updatedMeasurements.doorWidth > 0
            && updatedMeasurements.height > 0;
        if (updatedMeasurements.doorType === 'customGlassWall'
            && !updatedMeasurements.glassWallInitialized
            && canInitializeGlassWall) {
            dispatch(restoreDefaultGlassWall());
        }
    }
};

const getPositioningWasMoved = (measurements) => ({
    door: Number(measurements.doorFromLeft) !== Number(measurements.defaultDoorFromLeft),
    stove: !positionsMatch(measurements.stovePosition, measurements.defaultStovePosition)
});

const applyBenchModelDefaultPositions = (dispatch, getState, positioningWasMoved) => {
    const state = getState();
    const measurements = state.measurements;
    if (!(measurements.doorWallWidth > 0 && measurements.depth > 0 && measurements.doorWidth > 0)) return;

    const bench = state.benchModel;
    const hasBench = Boolean(state.plan && state.plan.hasBench);
    const shape = hasBench ? bench.shape : null;
    const mirrored = hasBench && Boolean((bench.shape && bench.shape.mirrored) || bench.mirrored);
    const defaults = getBenchModelDefaultPositions(shape, measurements, mirrored);

    if (!positioningWasMoved.door) {
        dispatch(doorFromLeftUpdated(defaults.doorFromLeft));
    }
    if (!positioningWasMoved.stove) dispatch(stovePositionUpdated(defaults.stovePosition));
    dispatch({
        type: 'POSITIONING_DEFAULTS_SET',
        doorFromLeft: defaults.doorFromLeft,
        stovePosition: defaults.stovePosition
    });
};

export const applyLayoutDefaultPositions = () => (dispatch, getState) => {
    const positioningWasMoved = getPositioningWasMoved(getState().measurements);
    applyBenchModelDefaultPositions(dispatch, getState, positioningWasMoved);
};

export const filterShapes = () => {
    return (dispatch, getState) => {
        let state = getState();
        if (state.clientConfiguration.filterShapesBySize)
            dispatch({ type: 'FILTER_SHAPES', measurements:state.measurements });
    };
}

export const skipStoveAndDoorPositioning = () => {
    return {
        type: 'UPDATE_POSITIONING_SKIPPED',
        value: true
    };
}
export const enableStoveAndDoorPositioning = () => {
    return {
        type: 'UPDATE_POSITIONING_SKIPPED',
        value: false
    };
}


export const skipMeasurements = () => {
    return { type: 'MEASUREMENTS_SKIPPED' };
};
export const measurementsGiven = () => {
    return { type: 'MEASUREMENTS_GIVEN' };
};


export const stovePositionUpdated = (stovePosition) => {
    return (dispatch) => {
        dispatch({
            type: 'STOVEPOSITION_UPDATED',
            stovePosition: stovePosition
        });
        dispatch(updateCadImage());
    }
};

export const restoreDefaultPositions = () => {
    return (dispatch, getState) => {
        const state = getState();
        const measurements = state.measurements;
        if (state.clientConfiguration.canMoveDoor) {
            dispatch(doorFromLeftUpdated(measurements.defaultDoorFromLeft));
        }
        if (state.clientConfiguration.canMoveStove) {
            dispatch(stovePositionUpdated(measurements.defaultStovePosition));
        }
    };
};

export const clientCofigurationUpdated = (configuration) => {
    return ((dispatch,getState) => {
        if (configuration.materials) dispatch(receiveMaterialUpdate(configuration.materials));
        dispatch({
            type: 'CLIENT_COFIGURATION_UPDATED',
            configuration: configuration
        });
        if (configuration.avalaibleBenhcModels) {
            let state = getState();
            if (!configuration.avalaibleBenhcModels.find(b => b.name == state.benchModel.name)) {
                dispatch(changeModel(configuration.avalaibleBenhcModels[0]));
            }                
        }
        if (configuration.selectableProducts?.hasLights === false) {
            dispatch(changeLinghtning(lightType.NoLigthing));
        }
    });
}
export function fetchMaterials(retry = true) {
    return function (dispatch, getState) {
        dispatch(requestMaterials());
        let request = {
            headers: {
                'Content-Type': 'application/json'
            },
            retries: 3,
            retryDelay: 500
        };
        let params = new URLSearchParams({ "lang": getState().ui.language });
        let url = new URL(materialService);
        url.search = params.toString();
        return fetch_retry(url, request)
            .then(response => response.json())           
            .then(materials => dispatch(receiveMaterialUpdate(materials)))
            .then(() => getDefaultMaterials(getState()))
            .then(defaultMaterials => setDefaultMaterials(defaultMaterials, dispatch), () => dispatch(displayError(true, localization.appInMaintenanceState)));
    };
}
function setDefaultMaterials(defaultMaterials, dispatch) {
    dispatch(changePanelMaterial(defaultMaterials.defaultPanelMaterial));
    dispatch(changeBenchMaterial(defaultMaterials.defaultBenchMaterial));
    dispatch(changeProfileMaterial(defaultMaterials.defaultProfilematerial));
}



function getDefaultMaterials(state) {
    return {
        defaultBenchMaterial: state.plan.hasBench ? getDefaultBenchMaterial(state, state.benchModel.model).id : getBenchMaterials(state)[0].id,
        defaultPanelMaterial: getPanelMaterials(state)[0].id,
        defaultProfilematerial: getProfileMaterials(state)[0].id
    };
}
let imageCache = new benchImageCache();

const getImageDimensions = () => {
    let imageElement = document.getElementById("imagecontainer");
    return {
        width: Math.max(imageElement.clientWidth, 960),
        height: Math.max(Math.floor(imageElement.clientWidth / 1.6), 600)
    };
};


